import { ChangeComponent } from "checklist_page/change_component";
import React from "react";
import { Change } from "types";

export const Changelog = ({ changes }: { changes: Change[] }) => {
  const changeComponents = changes.map((change: Change) => (
    <ChangeComponent key={change.id} change={change} />
  ));

  return (
    <>
      <ul className="list-group list-group-flush">{changeComponents}</ul>
    </>
  );
};
